<div class="modal">
  <div class="top">
    <div class="left">
      <div class="tab" [ngClass]="{'active': activeTab === 'locale'}" (click)="activeTab = 'locale'">
        Language & Region
      </div>
      <div class="tab" [ngClass]="{'active': activeTab === 'currency'}" (click)="activeTab = 'currency'">
        Currency
      </div>
    </div>
    <div class="right">
      <div class="close-button-wrapper" (click)="close()">
        <svg-icon [svgStyle]="{'width.px': 18, 'height.px': 18}" src="/assets/icons/x.svg"></svg-icon>
      </div>
    </div>
  </div>
  <div class="bottom">
    <ng-container *ngIf="activeTab === 'locale'" i18n>
      <div class="header">Choose language and region</div>
      <div class="choices locales">
        <ng-container *ngFor="let locale of locales">
          <div class="row">
            <div class="choice-outer" [ngClass]="{'active': locale.name === currentLocale}" (click)="setLocale(locale)">
              <div class="flag">
                <span class="fi fi-{{locale.flag}}"></span>
              </div>
              <div class="choice">
                <div class="lang">{{ locale.language }}</div>
                <div class="country">{{ locale.country }}</div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="activeTab === 'currency'" i18n>
      <div class="header">Choose a currency</div>
      <div class="choices currencies">
        <ng-container *ngFor="let currency of currencies; trackBy: trackByCurrency">
          <div class="row">
            <div class="choice-outer" [ngClass]="{'active': currency.code === (currentCurrency | async)?.code}" (click)="setCurrency(currency)">
              <div class="choice">
                <div class="name">{{ currency.name }}</div>
                <div class="symbol">{{ currency.code }} - {{ currency.symbol_native }}</div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>
